/**
 * The product's name. Since t374u each company (workspace) has its own name and logo at runtime
 * (packages/shared/src/branding); this is what shows where no company is known (API docs, the default branding).
 * A company's title is `appTitle(company)` ("Trade Outlet - The Hub"). Internal identifiers (repo, packages,
 * schemas, env vars, storage keys) keep their old names on purpose; see docs/saas-branding-audit.md.
 */
import { PRODUCT_NAME } from './branding/branding';

export const APP_NAME = PRODUCT_NAME;
/** Short form for tight spaces and running text ("Open in The Hub"); also the PWA short_name. */
export const APP_SHORT_NAME = PRODUCT_NAME;
/** Browser tab title: the page first, the app title at the end; the base title is exactly `title` (default: the product). */
export const pageTitle = (page?: string | null, unread = 0, title: string = APP_NAME) =>
  `${unread > 0 ? `(${unread}) ` : ''}${page?.trim() ? `${page.trim()} · ${title}` : title}`;
